import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getDriverDetail,
  updateDriver,
} from "../../redux/actions/driverActions";
import DefaultLayout from "../../layouts/DefaultLayout";
import { toast } from "react-toastify";

function EditDriverScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { id } = useParams();

  const [loadEvent, setLoadEvent] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");

  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [logo, setLogo] = useState("");
  const [logoValue, setLogoValue] = useState("");
  const [logoError, setLogoError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const detailUser = useSelector((state) => state.detailDriver);
  const { loadingDriverInfo, driverInfo, errorDriverInfo, successDriverInfo } =
    detailUser;

  const driverUpdate = useSelector((state) => state.updateDriver);
  const { loadingDriverUpdate, errorDriverUpdate, successDriverUpdate } =
    driverUpdate;

  const redirect = "/";
  useEffect(() => {
    if (!userInfo) {
      navigate(redirect);
    } else {
      dispatch(getDriverDetail(id));
    }
  }, [navigate, userInfo, dispatch, id]);

  useEffect(() => {
    if (driverInfo && driverInfo !== null && driverInfo !== undefined) {
      setFirstName(driverInfo.first_name ?? "");
      setLastName(driverInfo.last_name ?? "");
      setCity(driverInfo.city ?? "");
      setEmail(driverInfo.email ?? "");
      setPhone(driverInfo.phone ?? "");
    }
  }, [driverInfo]);

  useEffect(() => {
    if (successDriverUpdate) {
      setFirstName("");
      setLastName("");
      setCity("");
      setEmail("");
      setPhone("");
      dispatch(getDriverDetail(id));
    }
  }, [successDriverUpdate, dispatch]);

  return (
    <DefaultLayout>
      <div className="animate-fadeIn">
        {/* Modern Breadcrumb */}
        <nav className="flex mb-6" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <a
                href="/dashboard"
                className="inline-flex items-center text-sm font-medium text-primary hover:text-secondary transition-colors duration-200"
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  ></path>
                </svg>
                Dashboard
              </a>
            </li>
            <li>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-secondary"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <a
                  href="/drivers"
                  className="ml-1 text-sm font-medium text-primary hover:text-secondary md:ml-2 transition-colors duration-200"
                >
                  Drivers
                </a>
              </div>
            </li>
            <li aria-current="page">
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-secondary"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span className="ml-1 text-sm font-medium text-secondary md:ml-2">
                  Edit Driver
                </span>
              </div>
            </li>
          </ol>
        </nav>

        {/* Header with background */}
        <div
          className="relative mb-8 rounded-xl overflow-hidden bg-gradient-to-r from-primary to-secondary shadow-lg"
          style={{
            backgroundImage: "url('/assets/background-auth-screen.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-primary/80 to-secondary/80"></div>
          <div className="relative z-10 px-6 py-8 md:px-10 md:py-12">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">
                  Edit Driver
                </h1>
                <p className="text-white/80 max-w-xl">
                  Update driver information and account details.
                </p>
              </div>
              <div className="mt-4 md:mt-0 bg-white/10 backdrop-blur-sm rounded-lg p-3 border border-white/20">
                <div className="flex items-center">
                  <div className="mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-white">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0a1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-white/70 text-xs">Driver ID</p>
                    <p className="text-white font-bold text-xl">#{id}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Form Container */}
        <div className="rounded-xl border border-stroke bg-white shadow-default overflow-hidden mb-8">
          <div className="p-6 md:p-8">
            {/* Form Section Title */}
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-black">Personal Information</h2>
              <p className="text-sm text-bodydark">Update the driver's personal details</p>
            </div>

            {/* Name Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-black mb-2">
                  First Name <span className="text-danger">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-bodydark">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                    </svg>
                  </div>
                  <input
                    className={`w-full pl-10 pr-4 py-3 rounded-lg border-2 ${
                      firstNameError ? "border-danger focus:border-danger" : "border-stroke focus:border-primary"
                    } outline-none transition-colors duration-200`}
                    type="text"
                    placeholder="Enter first name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                {firstNameError && (
                  <p className="mt-1 text-sm text-danger">
                    {firstNameError}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-black mb-2">
                  Last Name
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-bodydark">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                    </svg>
                  </div>
                  <input
                    className={`w-full pl-10 pr-4 py-3 rounded-lg border-2 ${
                      lastNameError ? "border-danger focus:border-danger" : "border-stroke focus:border-primary"
                    } outline-none transition-colors duration-200`}
                    type="text"
                    placeholder="Enter last name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
                {lastNameError && (
                  <p className="mt-1 text-sm text-danger">
                    {lastNameError}
                  </p>
                )}
              </div>
            </div>
            {/* Form Section Title */}
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-black">Contact Information</h2>
              <p className="text-sm text-bodydark">Update the driver's contact details</p>
            </div>

            {/* Contact Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-black mb-2">
                  Email Address <span className="text-danger">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-bodydark">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                    </svg>
                  </div>
                  <input
                    className={`w-full pl-10 pr-4 py-3 rounded-lg border-2 ${
                      emailError ? "border-danger focus:border-danger" : "border-stroke focus:border-primary"
                    } outline-none transition-colors duration-200`}
                    type="email"
                    placeholder="Enter email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {emailError && (
                  <p className="mt-1 text-sm text-danger">
                    {emailError}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-black mb-2">
                  Phone Number <span className="text-danger">*</span>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-bodydark">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                    </svg>
                  </div>
                  <input
                    className={`w-full pl-10 pr-4 py-3 rounded-lg border-2 ${
                      phoneError ? "border-danger focus:border-danger" : "border-stroke focus:border-primary"
                    } outline-none transition-colors duration-200`}
                    type="text"
                    placeholder="Enter phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                {phoneError && (
                  <p className="mt-1 text-sm text-danger">
                    {phoneError}
                  </p>
                )}
              </div>
            </div>

            {/* Location Fields */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-black mb-2">
                City <span className="text-danger">*</span>
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-bodydark">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                  </svg>
                </div>
                <input
                  className={`w-full pl-10 pr-4 py-3 rounded-lg border-2 ${
                    cityError ? "border-danger focus:border-danger" : "border-stroke focus:border-primary"
                  } outline-none transition-colors duration-200`}
                  type="text"
                  placeholder="Enter city"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
              </div>
              {cityError && (
                <p className="mt-1 text-sm text-danger">
                  {cityError}
                </p>
              )}
            </div>
            {/* Form Section Title */}
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-black">Account Security</h2>
              <p className="text-sm text-bodydark">Update the driver's password (leave blank to keep current password)</p>
            </div>

            {/* Password Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-black mb-2">
                  New Password
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-bodydark">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                    </svg>
                  </div>
                  <input
                    className={`w-full pl-10 pr-4 py-3 rounded-lg border-2 ${
                      passwordError ? "border-danger focus:border-danger" : "border-stroke focus:border-primary"
                    } outline-none transition-colors duration-200`}
                    type="password"
                    placeholder="Enter new password (optional)"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                {passwordError && (
                  <p className="mt-1 text-sm text-danger">
                    {passwordError}
                  </p>
                )}
                <p className="mt-1 text-xs text-bodydark">
                  Leave blank to keep the current password
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-black mb-2">
                  Confirm New Password
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-bodydark">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                  </div>
                  <input
                    className={`w-full pl-10 pr-4 py-3 rounded-lg border-2 ${
                      confirmPasswordError ? "border-danger focus:border-danger" : "border-stroke focus:border-primary"
                    } outline-none transition-colors duration-200`}
                    type="password"
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    disabled={!password}
                  />
                </div>
                {confirmPasswordError && (
                  <p className="mt-1 text-sm text-danger">
                    {confirmPasswordError}
                  </p>
                )}
              </div>
            </div>
            {/* Form Actions */}
            <div className="border-t border-stroke pt-6 flex flex-col-reverse md:flex-row items-center justify-between gap-4">
              <a
                href="/drivers"
                className="w-full md:w-auto px-6 py-3 rounded-lg border-2 border-stroke text-black font-medium hover:bg-gray-1 transition-colors duration-200 text-center"
              >
                Cancel
              </a>

              <button
                onClick={async () => {
                  // Reset all error states
                  setFirstNameError("");
                  setLastNameError("");
                  setEmailError("");
                  setPhoneError("");
                  setConfirmPasswordError("");
                  setPasswordError("");
                  setLogoError("");
                  setCityError("");

                  let isValid = true;

                  // Validate required fields
                  if (firstName.trim() === "") {
                    setFirstNameError("First name is required");
                    isValid = false;
                  }

                  if (email.trim() === "") {
                    setEmailError("Email address is required");
                    isValid = false;
                  } else if (!/\S+@\S+\.\S+/.test(email)) {
                    setEmailError("Please enter a valid email address");
                    isValid = false;
                  }

                  if (phone.trim() === "") {
                    setPhoneError("Phone number is required");
                    isValid = false;
                  }

                  if (city.trim() === "") {
                    setCityError("City is required");
                    isValid = false;
                  }

                  // Only validate password if it's provided (since it's optional in edit mode)
                  if (password !== "") {
                    if (password.length < 6) {
                      setPasswordError("Password must be at least 6 characters");
                      isValid = false;
                    }

                    if (password !== confirmPassword) {
                      setConfirmPasswordError("Passwords do not match");
                      isValid = false;
                    }
                  }

                  if (isValid) {
                    setLoadEvent(true);
                    try {
                      dispatch(
                        updateDriver(id, {
                          first_name: firstName,
                          last_name: lastName,
                          full_name: firstName + " " + lastName,
                          email: email,
                          phone: phone,
                          city: city,
                          password: password || undefined, // Only send password if it's provided
                        })
                      );

                      // If we get here without errors, show success message
                      if (!errorDriverUpdate) {
                        toast.success("Driver updated successfully!");
                      }
                    } catch (error) {
                      toast.error("Failed to update driver. Please try again.");
                    } finally {
                      setLoadEvent(false);
                    }
                  } else {
                    toast.error("Please fix the errors in the form");
                  }
                }}
                disabled={loadingDriverUpdate}
                className={`w-full md:w-auto px-6 py-3 rounded-lg font-medium text-white ${
                  loadingDriverUpdate
                    ? "bg-primary/70 cursor-not-allowed"
                    : "bg-primary hover:bg-primary/90 transition-colors duration-200"
                }`}
              >
                {loadingDriverUpdate ? (
                  <div className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Updating Driver...
                  </div>
                ) : (
                  "Update Driver"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
}

export default EditDriverScreen;
